import { Box, Typography, Fade } from "@mui/material";

const LoadingScreen = () => {
  return (
    <Fade in timeout={800}>
      <Box
        sx={{
          height: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >

        {/* Animated glow ring */}
        <Box
          sx={{
            width: 70,
            height: 70,
            borderRadius: "50%",
            border: "6px solid rgba(0, 255, 200, 0.3)",
            borderTopColor: "rgba(0, 255, 200, 0.9)",
            animation: "spin 1.5s linear infinite",
            mb: 4,
          }}
        />

        {/* App Name */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            letterSpacing: 1.5,
            animation: "pulse 1.8s ease-in-out infinite",
            textTransform: "uppercase",
          }}
        >
          Loading…
        </Typography>

        {/* Sub-text */}
        <Typography sx={{ mt: 2, opacity: 0.7 }}>
          Preparing your experience
        </Typography>

        {/* Keyframe animations */}
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }

            @keyframes pulse {
              0%, 100% { opacity: 1; transform: scale(1); }
              50% { opacity: 0.5; transform: scale(0.98); }
            }
          `}
        </style>

      </Box>
    </Fade>
  );
};

export default LoadingScreen;
